import { chain, get, identity } from 'lodash';
import { getEmailBackgroundColor } from './get-email-background-color';
import { getEmailBackgroundUrl } from './get-email-background-url';
import { defaultBackgroundRepeat } from './defaults';
export function getEmailBackground(composerData) {
    return {
        color: getEmailBackgroundColor(composerData),
        url: getEmailBackgroundUrl(composerData),
        repeat: chain([
            get(composerData, 'background.data.image.backgroundRepeat'),
            get(composerData, 'styles.css.so-global-html-background-image.backgroundRepeat'),
            defaultBackgroundRepeat,
        ])
            .filter(identity)
            .first()
            .value(),
    };
}
//# sourceMappingURL=get-email-background.js.map